export function Loading() {
  return (
    <div class="flex items-center justify-center py-12 text-anvil-400">
      <div class="animate-pulse">loading…</div>
    </div>
  );
}
